import { Alert } from 'antd';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
  padding-top: 4px;
  padding-bottom: 4px;
  margin-top: 5px;
`;
